const DEFAULT_DEV_ENV_KEY = "test";
const DEV_ENV_KEY_STORAGE = "web_page_render_dev_env";

const testDevSiteConfig = {
  label: "测试环境",
  shopBackUrl: "http://xjhy.shopmember-test.omszt.com:7888",
  collectionH5SiteUrl: "http://xjhy.m-shop-test.omszt.com:7888",
};

const onlineDevSiteConfig = {
  label: "线上环境",
  shopBackUrl: "https://cnspacebuy.com",
  collectionH5SiteUrl: "https://cnspacebuy.com",
};

const sztbuySassDevSiteConfig = {
  label: "sztbuysass 商城",
  shopBackUrl: "https://mall.sztbuysass.omszt.com",
  collectionH5SiteUrl: "https://mall.sztbuysass.omszt.com",
};

export const userCenterDevSiteConfigMap = {
  test: testDevSiteConfig,
  online: onlineDevSiteConfig,
  production: onlineDevSiteConfig,
  sztbuysass: sztbuySassDevSiteConfig,
};

function safeGetStorageValue(key: string): string {
  if (typeof window === "undefined" || !window.localStorage) {
    return "";
  }

  try {
    return String(window.localStorage.getItem(key) || "").trim();
  } catch (error) {
    return "";
  }
}

function normalizeDevEnvKey(rawKey = ""): keyof typeof userCenterDevSiteConfigMap {
  const envKey = String(rawKey || "").trim() as keyof typeof userCenterDevSiteConfigMap;
  if (envKey && userCenterDevSiteConfigMap[envKey]) {
    return envKey;
  }
  return DEFAULT_DEV_ENV_KEY;
}

export function getCurrentUserCenterDevEnvKey(): keyof typeof userCenterDevSiteConfigMap {
  return normalizeDevEnvKey(
    process.env.DEV_SITE_ENV
    || process.env.NUXT_PUBLIC_DEV_SITE_ENV
    || safeGetStorageValue(DEV_ENV_KEY_STORAGE)
    || DEFAULT_DEV_ENV_KEY,
  );
}

export function getCurrentUserCenterDevSiteConfig() {
  return userCenterDevSiteConfigMap[getCurrentUserCenterDevEnvKey()] || userCenterDevSiteConfigMap.test;
}

export function isLocalDebugHost(host = ""): boolean {
  const normalizedHost = String(host || "").trim().toLowerCase();
  if (!normalizedHost) {
    return false;
  }

  return [
    "localhost",
    "127.0.0.1",
    "0.0.0.0",
    "192.168",
    "172.16",
    "172.17",
    "172.18",
    "172.19",
    "172.20",
    "172.21",
    "172.22",
    "172.23",
    "172.24",
    "172.25",
    "172.26",
    "172.27",
    "172.28",
    "172.29",
    "172.30",
    "172.31",
    "172.168",
  ].some(segment => normalizedHost.indexOf(segment) >= 0);
}

export function getQueryDealerShopBackUrl(locationLike = typeof window !== "undefined" ? window.location : undefined): string {
  const host = String(locationLike?.host || "").trim();
  if (isLocalDebugHost(host)) {
    return getCurrentUserCenterDevSiteConfig().shopBackUrl;
  }

  if (locationLike?.origin) {
    return String(locationLike.origin).trim();
  }

  const protocol = String(locationLike?.protocol || "http:").trim();
  return host ? `${protocol}//${host}` : getCurrentUserCenterDevSiteConfig().shopBackUrl;
}

export function getDefaultCollectionH5SiteUrl(): string {
  return getCurrentUserCenterDevSiteConfig().collectionH5SiteUrl;
}
